import React from 'react';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import shape4 from "../../../assets/images/shapes/shape-06.png";
import two from "../../../assets/images/banner/banner-bg.png";
import carousel01 from "../../../assets/images/carousel/ig45.png";
import carousel02 from "../../../assets/images/carousel/ig59.png";
import carousel03 from "../../../assets/images/carousel/ig61.png";
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';

const Banner = () => {

    const slideData = [
        // {
        //     subtitle: "Innovating Tomorrow",
        //     title: "Advanced Solutions",
        //     titleTail: "Engineering & <span>Healthcare</span>",
        //     image: carousel01,
        //     description: "Delivering cutting-edge tech through research and strategic partnerships with defense and healthcare leaders."
        // },
        // {
        //     subtitle: "Engineering Excellence",
        //     title: "Solving Complex",
        //     titleTail: "Challenges with <span>Innovation</span>",
        //     image: carousel02,
        //     description: "Combining software and hardware expertise to create custom solutions for defense, healthcare, and academia."
        // },
        // {
        //     subtitle: "Trusted Partnerships",
        //     title: "Partnering with",
        //     titleTail: "Government & <span>Industry</span>",
        //     image: carousel03,
        //     description: "Driving innovation through collaboration with DoD agencies, universities, and private firms to meet critical needs."
        // }
        {
            subtitle: "EPITOME OF INNOVATION",
            title: "Engineering the Future with",
            titleTail: "<span>Technology</span>",
            image: carousel03,
            description: "Creating next-generation solutions in engineering, life sciences, and healthcare."
        }
    ];

    return (

        <section className="banner__two slider-two p_relative">
            <div className="pattern-layer">
                <div className=" pattern-1 p_absolute" data-parallax='{"x": 100}' style={{ backgroundImage: `url(${shape4})` }}></div>
            </div>
            <div className="image-layer p_absolute" style={{ backgroundImage: `url(${two})` }}></div>
            <div className="banner__data__two p_relative">
                <OwlCarousel
                    className="banner-carousel owl-theme owl-carousel owl-dots-none"
                    items={1}
                    loop={true}
                    margin={0}
                    smartSpeed={1000}
                    autoplay={6000}
                    responsive={{
                        0: {
                            items: 1,
                        },
                        600: {
                            items: 1,
                        },
                        768: {
                            items: 1,
                        },
                        992: {
                            items: 1,
                        },
                        1200: {
                            items: 1,
                        },
                    }}
                >
                    {slideData.map((slide, index) => (
                        <div className="slide-item p_relative" key={index}>
                            <div className="auto-container">
                                <div className="row">
                                    <div className="col-lg-8 col-md-12">
                                        <div className="content-box p_relative">
                                            <div className="sub__title">
                                                <h4 className="p_relative">
                                                    <span className="slider-text-anim two">{slide.subtitle}</span>
                                                </h4>
                                            </div>
                                            <h2 className="p_relative">
                                                <span className="slider-text-anim">{slide.title.split(' :: ')[0]} </span>
                                                <span className="slider-text-anim title__last">
                                                    {parse(slide.titleTail)}
                                                </span>
                                            </h2>
                                            <p>{slide.description}</p>
                                            <div className="btn-box">
                                                <Link to="/contact" className="theme-btn theme-btn-one">
                                                    <i className="icon-02"></i> Contact Us
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div className="col-lg-4 col-md-12">
                                        <div className="content-box-image">
                                            <img src={slide.image} />
                                        </div>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    ))}
                </OwlCarousel>
                <div className="banner__bottom">
                    <div className="row">
                        <div className="col-lg-6 col-md-12"></div>
                        <div className="col-lg-6 col-md-12">
                            <div className="banner__mission__block">
                                <div className="mission__block">
                                    <h3>Our Vision</h3>
                                    {/* <p>To lead in innovative solutions at the intersection of engineering, life sciences, and healthcare.</p> */}
                                    <p>To drive innovation and develop cutting-edge solutions that address complex challenges in engineering, life sciences, and healthcare, shaping a better future through technology and collaboration.</p>
                                </div>
                                <div className="mission__block">
                                    <h3>Our Mission</h3>
                                    <p>To advance science and technology by delivering high-impact solutions in engineering, life sciences, and healthcare through research, development, and strategic partnerships.</p>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Banner;
